import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_AUTORIZADOR_PORT}${process.env.VUE_APP_API_PATH}/autorizadorfinanceiro`;

const urlBase = `${api}/borderos`;

export default {
    obterTodos() {
        return axiosJwt.get(`${urlBase}`);
    },

    aprovarBordero(borderoReprovadoDto) {
        return axiosJwt.patch(`${urlBase}/aprovar`, borderoReprovadoDto);
    },

    reprovarBordero(borderoAprovadoDto) {
        return axiosJwt.patch(`${urlBase}/reprovar`, borderoAprovadoDto);
    },

    buscarBorderosRm() {
        return axiosJwt.post(`${urlBase}/buscar-borderos-rm`);
    },

    obterPorId(borderoId) {
        return axiosJwt.get(`${urlBase}/${borderoId}`);
    },
};
